<template>
  <div class="wrapper">
    <a v-for="item in items" :key="item.pid" :href="'https://shopping.friday.tw/product?pid='+item.pid">
      <img :src="item.image_url" :alt="item.name">
      <div class="desc">
        <div class="box">
          <div class="title">{{ item.name }}</div>
        </div>
        <p v-if="item.promotion" class="promotion">{{ item.promotion }}</p>
        <div class="box">
          <div class="priceBox">
            <p class="retailPrice">{{ Intl.NumberFormat().format(item.list_price) }}</p>
            <p class="price">{{ Intl.NumberFormat().format(item.price) }}</p>
          </div>
          <p class="button">立即購買</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "TwoBlocks",
  props: {
    items: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/color";
@import "../style/mixin";
@import "../style/rwd.module.scss";

a {
  width: calc((950px - 48px) / 2);
  height: 260px;
  background-color: $white;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
}

img {
  width: 260px;
  aspect-ratio: 1/1;
  border-radius: 10px 0 0 10px;
}

.wrapper {
  display: flex;
  gap: 8px;
  &.darkMode {
    @include darkMode;
  }
}

.desc {
  @include desc;
}

.box {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  @include title(22px, $black);
  @include font-break($line: 3);
}

.promotion {
  @include promotion;
}

.retailPrice {
  @include retailPrice(15px);
}

.price {
  @include price(35px);
}

.button {
  @include button;
}

@media screen and (max-width: 950px) {
  a {
    width: 100%;
    height: fit-content;
  }

  .wrapper {
    flex-direction: column;

    img {
      width: 160px;
    }

    .box {
      min-height: unset;
      padding: 7px;
    }

    .title {
      font-size: 1.7rem;
      @include font-break($line: 2);
    }

    .priceBox {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
    }

    .retailPrice {
      font-size: 12px;
    }

    .price {
      font-size: 2rem;
      &::before {
        font-size: 1.5rem;
      }
    }

    .button {
      font-size: 1.4rem;
    }
  }
}
</style>
